<template>
    <v-container grid-list v-if="item.canTrack">
        <v-alert outlined type="error" prominent border="left" class="ma-4" v-if="locationError">
            Não foi possível usar a sua geolocalização. <br /><br />
            Favor verificar se o seu celular está com esse recurso habilitado.
        </v-alert>
        <v-card class="pa-4" v-else>
            <div class="d-flex justify-space-between align-center">
                <div class="flex-grow-1">
                    <v-card-title>Localização</v-card-title>
                    <v-card-subtitle>
                        Seu usuário está com a localização {{ canTrack ? 'ativada' : 'desativada' }}.
                    </v-card-subtitle>
                </div>
                <v-btn @click="toggleTracking" :color="canTrack ? 'error' : 'success'" class="ml-4">
                    {{ trackingLabel }}
                    <v-icon right>{{ canTrack ? 'mdi-map-marker-off' : 'mdi-map-marker-check' }}</v-icon>
                </v-btn>
            </div>
        </v-card>

        <v-dialog v-model="showConfirmDialog" max-width="400">
            <v-card>
                <v-card-title class="headline">Desativar Localização?</v-card-title>
                <v-card-text>
                    Tem certeza que deseja desativar a localização?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="showConfirmDialog = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="error" text @click="confirmToggleTracking">
                        Desativar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import locationHelper from "@/helpers/location";

export default {
    props: {
        item: {
            required: true,
        },
    },

    data() {
        return {
            timer: null,
            canTrack: this.$store.getters.isTrackingEnabled,
            showConfirmDialog: false,
            locationError: false,
        };
    },

    mounted() {
        if (this.item.canTrack) {
            this.update();
            this.timer = setInterval(this.update, 60 * 1000);
        }
    },

    computed: {
        trackingLabel() {
            return this.canTrack ? this.$t("Desativar Localização") : this.$t("Ativar Localização");
        },
    },

    methods: {
        async update() {
            if (!this.$store.getters.isTrackingEnabled) return;
            await locationHelper.get().then(loc => {
                this.locationError = false;
                this.$http
                    .postSilent(`/expert-tracking/${this.item.expertId}`, {
                        latitude: loc[0],
                        longitude: loc[1],
                    }, );
            }).catch(() => {
                this.locationError = true;
            });
        },

        toggleTracking() {
            if (this.canTrack) {
                this.showConfirmDialog = true;
            } else {
                this.confirmToggleTracking();
            }
        },

        confirmToggleTracking() {
            this.canTrack = !this.canTrack;
            this.$store.commit("TRACKING_ENABLED", this.canTrack);
            this.showConfirmDialog = false;
        },
    },
    
    beforeDestroy() {
        clearInterval(this.timer);
    },
};
</script>